import { IRefusalAnalytics } from "@/types/IAnalytics"


export interface useAnalyticsProps {
}

export interface ITotalNumberAnalytics {
  key: string
  value: number
}

export const useAnalytics = (props: useAnalyticsProps) => {
  
  const getTotalNumberAnalytics = (data: any[]) => {
    const array: ITotalNumberAnalytics[] = []
    if (data && data.length > 0) {
      Object.entries(data[0]).forEach(([key, value]) => {        
        if (typeof value === "number") {            
          array.push({ key, value: parseFloat(data.map(x => x[key as keyof any] as number).reduce((a, n) => (a + n), 0).toFixed(3)) })         
        }
      })      
    }
    return array
  }

  return {
    getTotalNumberAnalytics
  }
}
